export enum STORAGE_KEYS { // eslint-disable-line no-shadow
  LANGUAGE = 'NG_TRANSLATE_LANG_KEY',
  AUTH = 'AUTH',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATIONS_TOKEN',
  CURRENT_TENANT_ID = 'CURRENT_TENANT_ID',
  CURRENT_NEWSFEED_FILTERS = 'CURRENT_NEWSFEED_FILTERS',
  CURRENT_EVENTS_FILTERS = 'CURRENT_EVENTS_FILTERS',
  RESIDENT_ORIGIN_DEFAULT_MIGRATED = 'RESIDENT_ORIGIN_DEFAULT_MIGRATED',
  RESIDENT_ORIGIN_ALL_POSTS_APPLIED = 'RESIDENT_ORIGIN_ALL_POSTS_APPLIED',
  ONBOARDING_DONE = 'ONBOARDING_DONE'
}
